import React, { ChangeEvent, useState } from "react"
import {
    CardNumberElement,
    ReactStripeElements,
    CardExpiryElement,
    CardCvcElement
} from "react-stripe-elements"
import { CreditCardInput } from "dash-styled"
import styles from "./StripePaymentMethodInput.module.css"

const CARD_NUMBER_DOM_ID = "card-number"
const CARD_EXPIRE_DOM_ID = "card-expiry"
const CARD_OWNER_DOM_ID = "card-owner"
const CARD_CVV_DOM_ID = "card-cvv"

interface StripePaymentMethodInputProps {
    onChange: (isComplete: boolean, name: string) => void
}

export const StripePaymentMethodInput = ({
    onChange
}: StripePaymentMethodInputProps) => {
    const [name, setName] = useState("")
    const [isNumberOk, setNumberOk] = useState(false)
    const [isExpiryOk, setExpiryOk] = useState(false)
    const [isCvcOk, setCvcOk] = useState(false)
    const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value)
        onChange(isNumberOk && isExpiryOk && isCvcOk, e.target.value)
    }
    const handleChangeNumber = (
        e: ReactStripeElements.ElementChangeResponse
    ) => {
        setNumberOk(e.complete)
        onChange(e.complete && isExpiryOk && isCvcOk, name)
    }
    const handleChangeExpiry = (
        e: ReactStripeElements.ElementChangeResponse
    ) => {
        setExpiryOk(e.complete)
        onChange(isNumberOk && e.complete && isCvcOk, name)
    }
    const handleChangeCvc = (e: ReactStripeElements.ElementChangeResponse) => {
        setCvcOk(e.complete)
        onChange(isNumberOk && isExpiryOk && e.complete, name)
    }

    return (
        <CreditCardInput
            cardNumberId={CARD_NUMBER_DOM_ID}
            expireId={CARD_EXPIRE_DOM_ID}
            ownerId={CARD_OWNER_DOM_ID}
            cvvId={CARD_CVV_DOM_ID}
            cardNumberInput={
                <CardNumberElement
                    id={CARD_NUMBER_DOM_ID}
                    onChange={handleChangeNumber}
                    classes={{ base: styles.CardInput__CardNumberInput }}
                    placeholder="••••   ••••   ••••  1384"
                    style={{
                        base: {
                            color: "rgb(53, 28, 79)",
                            fontSize: "25px",
                            textAlign: "left",
                            letterSpacing: "6px",
                            "::placeholder": {
                                color: "#8b93ad"
                            }
                        }
                    }}
                />
            }
            expireInput={
                <CardExpiryElement
                    id={CARD_EXPIRE_DOM_ID}
                    placeholder="09/23"
                    onChange={handleChangeExpiry}
                    style={{
                        base: {
                            fontSize: "16px",
                            textAlign: "right",
                            color: "#351c4f",
                            "::placeholder": {
                                color: "rgba(53, 28, 79, 0.5)"
                            }
                        }
                    }}
                />
            }
            cvvInput={
                <CardCvcElement
                    id={CARD_CVV_DOM_ID}
                    onChange={handleChangeCvc}
                    placeholder="123"
                    style={{
                        base: {
                            color: "rgb(53, 28, 79)",
                            fontSize: "18px",
                            textAlign: "right",
                            letterSpacing: "2px",
                            "::placeholder": {
                                color: "#8b93ad"
                            }
                        }
                    }}
                />
            }
            ownerInput={
                <input
                    id={CARD_OWNER_DOM_ID}
                    className={styles.CardInput__CardNumberOwner}
                    value={name}
                    placeholder="John Smith"
                    onChange={handleChangeName}
                    style={{
                        width: "200px",
                        fontSize: "16px",
                        textAlign: "left",
                        color: "#351c4f"
                    }}
                />
            }
        />
    )
}
